import { connect } from 'react-redux';
import { RootState } from '../reducers/root';
import { MessageBox } from '../components/FormulationSpace/MessageBox';

const mapStateToProps = (state: RootState) => ({
  errorMessage: state.UserInputState.errorMessage
});

export default connect(mapStateToProps)(MessageBox);
